<div class="mac-address-form-container">
    <div class="mac-address-form-card">
        <owc-card dragging elevated rounded class="card">
            <owc-component-header slot="header">
                <h2> cobas® liat analyzer Mac Address Finder</h2>
            </owc-component-header>
            <div class="mac-address-content">
                <form [formGroup]='macAddressForm' (ngSubmit)='sendMacAddressRequest()'>
                    <owc-input formControlName='macAddresses' auto-focus controlled resizable rounded
                        type="textarea"
                        [name]="'Serial No.'" [rows]="rows" [placeholder]="'Enter Serial number(s)'" [cols]="cols">
                    </owc-input>
                    <owc-assistive-text class="assistive-text" trigger="input, blur">
                        Only digits are allowed. If your instruments serial number has the following format: "M1-E-00123", please enter only 00123. Separate serial numbers with comma or new line.
                    </owc-assistive-text>
                    <owc-assistive-text class="assistive-text validation-error" trigger="input, blur" *ngIf="macAddressForm.controls['macAddresses'].hasError('maxSerialnumberNumbers')">
                        Too many serial numbers please provide correct number.
                    </owc-assistive-text>
                    <div class="action-buttons">
                        <owc-button class="button" elevated size="medium" type="reset" variant="secondary">
                            Clear
                        </owc-button>
                        <owc-button class="button" [disabled]="macAddressForm.invalid" elevated size="medium" type="submit" variant="primary">
                            Submit
                        </owc-button>
                    </div>
                </form>
            </div>
        </owc-card>    
    </div>
</div>